import { getUserInfo } from 'ui-addon-upgrades/_core/common/api/getUserInfo';
import { getHasAcceptanceTestOverride, getQueryParam } from 'ui-addon-upgrades/_core/utils/commMethodOverrides';
import enviro from 'enviro';
export const getIsHubSpotOnCreditsPilot = () => {
  if ((enviro.isQa() || getHasAcceptanceTestOverride()) && getQueryParam('isHsocPilot') === 'true') {
    return Promise.resolve(true);
  }
  return getUserInfo().then(({
    user
  }) => {
    return user.scopes.includes('hubspot-on-credits');
  }).catch(() => {
    return false;
  });
};